import { logoPngSm } from "@";

// Hook for getting charity information
export const useCharity = () => {
  // const { data: apiConfigs, isLoading, isError } = useCharityConfigsQuery();

  const configs = {
    charityStoreUrl: import.meta.env.VITE_WEBSITE_URL || "#",
    charityLogo: import.meta.env.VITE_CHARITY_LOGO || logoPngSm,
    myFatoorahScriptSrc: import.meta.env.VITE_MYFATOORAH_SCRIPT_SRC,
    charityName: import.meta.env.VITE_CHARITY_NAME || "منصة خزامى للمتاجر",
  };

  document.title = configs.charityName;
  const favicon = document.querySelector("link[rel='icon']");
  if (favicon) {
    favicon.href = configs.charityLogo;
  }

  return {
    ...configs,
    isLoading: false,
    isError: false,
  };
};
